/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { all } from 'redux-saga/effects';

import {
  watchUpdateShellSettingsSaga,
  watchApplyShellSettingsSaga
} from './apply.shell.settings.saga';
import {
  watchConfigureViewPluginsSaga,
  watchApplyViewPluginsSaga
} from './configure.plugins.saga';
import watchLoadPluginSaga from './load.plugin.saga';
import watchModuleLoadedSaga from './module.loaded.saga';
import watchNavigateToSessionListSaga from './close.session.saga';
import {
  watchRouteLocationChangedSaga,
  watchSelectViewSaga,
  watchStatefulNavigationSaga
} from './navigation.saga';
import watchUnloadPluginSaga from './unload.plugin.saga';
import watchUpdateSessionSaga from './update.session.saga';

export default function* sessionViewSaga() {
  yield all([
    watchApplyShellSettingsSaga(),
    watchApplyViewPluginsSaga(),
    watchConfigureViewPluginsSaga(),
    watchLoadPluginSaga(),
    watchModuleLoadedSaga(),
    watchNavigateToSessionListSaga(),
    watchRouteLocationChangedSaga(),
    watchSelectViewSaga(),
    watchStatefulNavigationSaga(),
    watchUnloadPluginSaga(),
    watchUpdateSessionSaga(),
    watchUpdateShellSettingsSaga()
  ]);
}
